import Content from '../../content.js';

namespace('IO.Views.Locations', function (exports) {
  'use strict';

  var Show = Content.extend({
    APPLIANCES_STATUS_CHANNEL: `/${currentCustomer}/appliances/status`,
    EXPORTERS_JOBS_CHANNEL: `/${currentCustomer}/exporters_jobs`,
    REMOTE_JOBS_CHANNEL: `/${currentCustomer}/remote_jobs`,

    APPLIANCES_TABLE_CONTAINER: 0,

    beforeFilter: function () {
      this.initializer = new Initializer();
      this.tableContainers = [
        $('#appliances-table-container'),
        $('#active-jobs-table-container'),
      ];

      document.addEventListener(
        'turbolinks:before-visit',
        () => {
          this.stopListening();
        },
        { once: true },
      );
      this.startListening();
    },

    afterRender: function () {
      this.tableContainers.forEach(($tableContainer) => {
        $tableContainer.on('htmx:afterSwap', () => {
          this.initializer.register();
          this.bindRowClick($tableContainer);
        });
        this.bindRowClick($tableContainer);
      });
      this.bindAcuvigilLink();
    },

    bindAcuvigilLink: function () {
      $('#acuvigil-link').on('click', function (event) {
        event.preventDefault();

        $.ajax({
          method: 'GET',
          url: `${window.location.pathname}/acuvigil_link`,
          data: { login_url: window.location.href },
          success: function (response) {
            window.open(response.url, '_blank', 'noopener,noreferrer');
          },
        });
      });
    },

    bindRowClick: function (containerElement) {
      $(containerElement)
        .find('.paginated-table table.collection tbody')
        .off('click')
        .on('click', function (event) {
          const $row = $(event.target.closest('tr'));
          if ($row.length > 0 && $row.attr('href') !== '') {
            Turbolinks.visit($row.attr('href'));
          }
        });
    },

    startListening: function () {
      if (!this.appliancesStatusChannel) {
        this.appliancesStatusChannel = Messenger.on(
          this.APPLIANCES_STATUS_CHANNEL,
          this.updateAppliancesStatuses.bind(this),
        );
      }

      if (!this.exportersJobsChannel) {
        this.exportersJobsChannel = Messenger.on(
          this.EXPORTERS_JOBS_CHANNEL,
          this.updateActiveJobRow.bind(this),
        );
      }

      if (!this.remoteJobsChannel) {
        this.remoteJobsChannel = Messenger.on(
          this.REMOTE_JOBS_CHANNEL,
          this.updateActiveJobRow.bind(this),
        );
      }
    },

    stopListening: function () {
      if (this.appliancesStatusChannel) {
        Messenger.off(
          this.APPLIANCES_STATUS_CHANNEL,
          this.updateAppliancesStatuses,
        );
        this.appliancesStatusChannel = null;
      }

      if (this.exportersJobsChannel) {
        Messenger.off(this.EXPORTERS_JOBS_CHANNEL, this.updateActiveJobRow);
        this.exportersJobsChannel = null;
      }

      if (this.remoteJobsChannel) {
        Messenger.off(this.REMOTE_JOBS_CHANNEL, this.updateActiveJobRow);
        this.remoteJobsChannel = null;
      }
    },

    updateAppliancesStatuses: function () {
      const $rows = this.tableContainers[this.APPLIANCES_TABLE_CONTAINER].find(
        'table.collection#appliances-table tbody tr',
      );

      $.ajax({
        method: 'GET',
        url: `${window.location.pathname}/appliances/status`,
        success: function (appliances) {
          for (const appliance of appliances) {
            var $status = $rows
                .filter(`[data-hostname=${appliance.hostname}]`)
                .find('td.status > span.sensu-status'),
              oldStatus = $status.prop('title');

            $status.removeClass(`sensu-status-${oldStatus}`);
            $status.addClass(`sensu-status-${appliance.status}`);
            $status.prop('title', appliance.status);
            $status.text(appliance.status);
          }
        }.bind(this),
      });
    },

    updateActiveJobRow: function (job) {
      const jobType =
          job.type === undefined
            ? 'exportersjob'
            : job.type.toLowerCase().slice(0, -3),
        rowId = `table.collection#active-jobs-table tbody tr#active-job-${jobType}-${job.id}`;

      if (document.querySelector(rowId) === null) {
        return;
      }

      htmx.ajax(
        'GET',
        `${window.location.pathname}/active_jobs/row/${job.type === undefined ? 'exporter' : 'remote'}/${job.id}`,
        {
          target: rowId,
          swap: 'outerHTML swap:0.1s',
        },
      );
    },
  });

  exports.Show = Show;
});
